function cov_hom0yr95o() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Bathroom.tsx";
  var hash = "8816d888b82c8706ba5fd07e74a611144a9b15d2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Bathroom.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8816d888b82c8706ba5fd07e74a611144a9b15d2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hom0yr95o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_hom0yr95o();
var Icon = (cov_hom0yr95o().s[0]++, {
  name: 'bathroom',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.75 3.80947C1.75 2.67205 2.67206 1.75 3.80947 1.75C7.92726 1.75 11.2654 5.08813 11.2654 9.20592V11.359H20.6538C21.5354 11.359 22.25 12.0737 22.25 12.9552C22.25 16.0193 20.0161 18.6255 16.9885 19.0944V22.25H5.98712L7.41106 18.755C7.7287 17.9753 7.4462 17.08 6.73864 16.6239L3.69713 14.663C2.48336 13.8805 1.75 12.5352 1.75 11.091V3.80947ZM4.25 4.26931V11.091C4.25 11.6856 4.55197 12.2396 5.05176 12.5618L8.09327 14.5227C9.81164 15.6305 10.4977 17.8048 9.72628 19.6982L9.70519 19.75H14.4885V18.3698C14.4885 17.5532 15.084 16.8588 15.8909 16.7342L16.6038 16.6242C18.1069 16.3922 19.283 15.2788 19.6388 13.859H11.1241C9.82142 13.859 8.76538 12.803 8.76538 11.5003V9.20592C8.76538 6.6173 6.78072 4.49222 4.25 4.26931Z\" fill=\"currentColor\"/>"
});
export default Icon;